import { NgModule } from '@angular/core';
import { FiDialogSelectLanguageComponent } from './dialog-select-language.component';
import { MatRadioModule } from '@angular/material/radio';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, MatRadioModule],
    declarations: [FiDialogSelectLanguageComponent],
    exports: [FiDialogSelectLanguageComponent],
})
export class FiDialogSelectLanguageModule {}
